import Event from '../../core/Event';

export default class EstimationsRequested extends Event {
    public static type = 'EstimationsRequested';

    constructor() {
        super(EstimationsRequested.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/estimations/events/EstimationsRequested.ts